module.exports = __webpack_public_path__ + "static/header-bannerbg-main-b4db644800adbe1427a7a2dd054e03af.png";